import {View, ColorValue, DimensionValue} from 'react-native';
import Svg, {
  Path,
  Line,
  Circle,
  Rect,
  ClipPath,
  G,
  Defs,
  Polyline,
  Mask,
} from 'react-native-svg';

export declare type IconValue =
  | 'nav-home'
  | 'nav-reports'
  | 'nav-people'
  | 'nav-equipment'
  | 'nav-operations'
  | 'task'
  | 'list-item-nav'
  | 'plus'
  | 'meeting-notes'
  | 'task-check'
  | 'site-inspection'
  | 'calendar'
  | 'eye'
  | 'clock'
  | 'pencil'
  | 'camera'
  | 'file'
  | 'picture'
  | 'eye-slash'
  | 'trash'
  | 'clipboard'
  | 'compass'
  | 'close'
  | 'checked'
  | 'training'
  | 'training-breakdown'
  | 'certification'
  | 'user-plus'
  | 'vehicle'
  | 'maintanence'
  | 'first-aid'
  | 'download'
  | 'input-search'
  | 'input-clear'
  | 'input-check'
  | 'input-filters'
  | 'hazard'
  | 'injury'
  | 'near-miss'
  | 'bear'
  | 'property-damage'
  | 'add'
  | 'harassment'
  | 'more'
  | 'convert'
  | 'close-circle'
  | 'arrow-down'
  | 'arrow-up'
  | 'collapse'
  | 'expand'
  | 'people-list'
  | 'projects-sites'
  | 'logout'
  | 'library'
  | 'folder'
  | 'print'
  | 'audit'
  | 'quick-add'
  | 'syncing'
  | 'question'
  | 'list'
  | 'company'
  | 'lock'
  | 'investigation'
  | 'locked'
  | 'unlocked'
  | 'save'
  | 'draft'
  | 'sorter'
  | 'zip'
  | 'doc-available-offline';

export declare type IconProps = {
  icon: IconValue;
  color: ColorValue;
  size: DimensionValue;
};

export default function Icon(props: IconProps) {
  const renderIcon = (color: ColorValue) => {
    switch (props.icon) {
      case 'nav-home':
        return renderNavHome(color);
      case 'nav-reports':
        return renderNavReports(color);
      case 'nav-people':
        return renderNavPeople(color);
      case 'nav-equipment':
        return renderNavEquipment(color);
      case 'nav-operations':
        return renderNavOperations(color);
      case 'task':
        return renderTask(color);
      case 'list-item-nav':
        return renderListItemNav(color);
      case 'plus':
        return renderPlus(color);
      case 'calendar':
        return renderCalendar(color);
      case 'clock':
        return renderClock(color);
      case 'pencil':
        return renderPencil(color);
      case 'camera':
        return renderCamera(color);
      case 'file':
        return renderFile(color);
      case 'picture':
        return renderPicture(color);
      case 'convert':
        return renderConvert(color);
      case 'meeting-notes':
        return renderMeetingNotes(color);
      case 'task-check':
        return renderTaskCheck(color);
      case 'close':
        return renderClose(color);
      case 'checked':
        return renderChecked(color);
      case 'site-inspection':
        return renderSiteInspection(color);
      case 'eye':
        return renderEye(color);
      case 'eye-slash':
        return renderEyeSlash(color);
      case 'trash':
        return renderTrash(color);
      case 'clipboard':
        return renderClipboard(color);
      case 'download':
        return renderDownload(color);
      case 'compass':
        return renderCompass(color);
      case 'training':
        return renderTraining(color);
      case 'training-breakdown':
        return renderTrainingBreakdown(color);
      case 'certification':
        return renderCertification(color);
      case 'user-plus':
        return renderUserPlus(color);
      case 'vehicle':
        return renderVehicle(color);
      case 'maintanence':
        return renderMaintanence(color);
      case 'first-aid':
        return renderFirstAid(color);
      case 'input-search':
        return renderInputSearch(color);
      case 'input-clear':
        return renderInputClear(color);
      case 'input-check':
        return renderInputCheck(color);
      case 'input-filters':
        return renderInputFilters(color);
      case 'hazard':
        return renderHazard(color);
      case 'injury':
        return renderInjury(color);
      case 'near-miss':
        return renderNearMiss(color);
      case 'bear':
        return renderBear(color);
      case 'property-damage':
        return renderPropertyDamage(color);
      case 'harassment':
        return renderHarassment(color);
      case 'add':
        return renderAdd(color);
      case 'more':
        return renderMore(color);
      case 'close-circle':
        return renderCloseCircle(color);
      case 'arrow-down':
        return renderArrowDown(color);
      case 'arrow-up':
        return renderArrowUp(color);
      case 'collapse':
        return renderCollapse(color);
      case 'expand':
        return renderExpand(color);
      case 'people-list':
        return renderPeopleList(color);
      case 'projects-sites':
        return renderProjectsSites(color);
      case 'logout':
        return renderLogout(color);
      case 'library':
        return renderLibrary(color);
      case 'folder':
        return renderFolder(color);
      case 'print':
        return renderPrint(color);
      case 'audit':
        return renderAudit(color);
      case 'quick-add':
        return renderQuickAdd(color);
      case 'syncing':
        return renderSyncing(color);
      case 'question':
        return renderQuestion(color);
      case 'list':
        return renderList(color);
      case 'company':
        return renderCompany(color);
      case 'lock':
        return renderLock(color);
      case 'investigation':
        return renderInvestigation(color);
      case 'locked':
        return renderLockedIcon(color);
      case 'unlocked':
        return renderUnlockedIcon(color);
      case 'draft':
        return renderDraftIcon(color);
      case 'sorter':
        return renderSorterIcon(color);
      case 'zip':
        return renderZipIcon(color);
      case 'doc-available-offline':
        return renderDocAvailableOffline(color);
      case 'save':
        return renderSave(color);
      default:
        return null;
    }
  };

  return (
    <View
      style={{
        width: props.size,
        height: props.size,
        aspectRatio: 1,
      }}>
      {renderIcon(props.color)}
    </View>
  );
}

const renderNavHome = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M9 22V12H15V22"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderNavReports = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M10.2898 3.86002L1.81978 18C1.64514 18.3024 1.55274 18.6453 1.55177 18.9945C1.55079 19.3438 1.64127 19.6872 1.8142 19.9905C1.98714 20.2939 2.2365 20.5468 2.53748 20.7239C2.83847 20.901 3.18058 20.9962 3.52978 21H20.4698C20.819 20.9962 21.1611 20.901 21.4621 20.7239C21.7631 20.5468 22.0124 20.2939 22.1854 19.9905C22.3583 19.6872 22.4488 19.3438 22.4478 18.9945C22.4468 18.6453 22.3544 18.3024 22.1798 18L13.7098 3.86002C13.5315 3.56613 13.2805 3.32314 12.981 3.15451C12.6814 2.98587 12.3435 2.89728 11.9998 2.89728C11.656 2.89728 11.3181 2.98587 11.0186 3.15451C10.7191 3.32314 10.468 3.56613 10.2898 3.86002V3.86002Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 9V13"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 17H12.01"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderNavPeople = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M14.9191 11.4143C14.9239 14.4706 12.4502 16.9521 9.39393 16.9569C6.33767 16.9617 3.85618 14.488 3.85137 11.4317C3.85066 10.9798 3.904 10.5412 4.0051 10.1216L14.7541 10.0758C14.8611 10.5038 14.9183 10.952 14.9191 11.4143Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7.33314 2.2052C6.44091 2.49516 5.62088 2.97721 4.94167 3.62427C3.77453 4.73616 3.11884 6.24421 3.11884 7.81667L9.3424 7.81667H15.566C15.566 6.24421 14.9103 4.73616 13.7431 3.62427C13.1276 3.03792 12.3965 2.58706 11.6008 2.29186"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Rect
        x="1.96771"
        y="7.81665"
        width="14.8398"
        height="2.21475"
        rx="0.241525"
        stroke={color}
        strokeWidth={2}
      />
      <Path
        d="M7.50865 1.73689C7.48018 1.38535 7.7578 1.08435 8.11049 1.08435H10.5755C10.9278 1.08435 11.2052 1.38466 11.1774 1.73583L10.9294 4.86768C10.9046 5.18111 10.6434 5.42305 10.329 5.42382L8.36596 5.42865C8.05081 5.42943 7.78806 5.1877 7.76263 4.87358L7.50865 1.73689Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5.91802 5.63219C6.02966 5.97337 6.39675 6.15945 6.73793 6.04781C7.07912 5.93617 7.2652 5.56908 7.15356 5.2279L5.91802 5.63219ZM5.05173 2.98474L5.91802 5.63219L7.15356 5.2279L6.28726 2.58045L5.05173 2.98474Z"
        fill={color}
      />
      <Path
        d="M12.8823 5.63219C12.7706 5.97337 12.4035 6.15945 12.0624 6.04781C11.7212 5.93617 11.5351 5.56908 11.6467 5.2279L12.8823 5.63219ZM13.7486 2.98474L12.8823 5.63219L11.6467 5.2279L12.513 2.58045L13.7486 2.98474Z"
        fill={color}
      />
      <Path
        d="M1.15515 27.5373V24.0533C1.15515 21.7857 2.99344 19.9474 5.26108 19.9474H13.5141C15.7817 19.9474 17.62 21.7857 17.62 24.0533V27.5611"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderNavEquipment = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M7.5 16L17.5 7C22.5 11 21 17.5 18 20C14.9032 22.5807 10.5 22 7.5 20.5C5.1 19.3 4.16667 16.3333 4 15L7.5 16Z"
        stroke={color}
        strokeWidth={2}
      />
      <Circle cx={14} cy={6} r={3} stroke={color} strokeWidth={2} />
      <Line
        x1={19.6585}
        y1={10.7526}
        x2={11.6585}
        y2={17.7526}
        stroke={color}
        strokeWidth={2}
      />
      <Path d="M7.88889 16L7 14L9 14.6667" stroke={color} strokeWidth={2} />
    </Svg>
  );
};

const renderNavOperations = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14 2V8H20"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16 13H8"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16 17H8"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10 9H9H8"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderTask = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M17.6662 3.57198C18.0325 3.20575 18.5292 3 19.0471 3C19.5651 3 20.0618 3.20575 20.428 3.57198C20.7943 3.93822 21 4.43494 21 4.95287C21 5.47081 20.7943 5.96753 20.428 6.33377L11.6824 15.0794L8 16L8.92059 12.3176L17.6662 3.57198Z"
        fill={color}
      />
      <Path
        d="M17.6662 3.57198C18.0325 3.20575 18.5292 3 19.0471 3C19.5651 3 20.0618 3.20575 20.428 3.57198C20.7943 3.93822 21 4.43494 21 4.95287C21 5.47081 20.7943 5.96753 20.428 6.33377L11.6824 15.0794L8 16L8.92059 12.3176L17.6662 3.57198Z"
        fill={color}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6738 9.67378L14.3262 8.32621L9.82355 12.8289L9.37436 14.6256L11.1711 14.1764L15.6738 9.67378ZM17.088 11.088L12.3895 15.7865C12.2613 15.9147 12.1007 16.0056 11.9249 16.0495L8.24253 16.9701C7.90175 17.0553 7.54126 16.9555 7.29288 16.7071C7.0445 16.4587 6.94465 16.0982 7.02985 15.7575L7.95044 12.0751C7.9944 11.8993 8.08532 11.7387 8.21348 11.6105L12.912 6.912L11 5H4.77778C4.30628 5 3.8541 5.1873 3.5207 5.5207C3.1873 5.8541 3 6.30628 3 6.77778V19.2222C3 19.6937 3.1873 20.1459 3.5207 20.4793C3.8541 20.8127 4.30628 21 4.77778 21H17.2222C17.6937 21 18.1459 20.8127 18.4793 20.4793C18.8127 20.1459 19 19.6937 19 19.2222V13L17.088 11.088Z"
        fill={color}
      />
    </Svg>
  );
};

const renderPlus = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <G clipPath="url(#clip0_5541_12436)">
        <Path
          d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M12 8V16"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M8 12H16"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_5541_12436">
          <Rect width={24} height={24} fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

const renderCalendar = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 21 21" fill="none">
      <Path
        d="M16.625 3.5H4.375C3.4085 3.5 2.625 4.2835 2.625 5.25V17.5C2.625 18.4665 3.4085 19.25 4.375 19.25H16.625C17.5915 19.25 18.375 18.4665 18.375 17.5V5.25C18.375 4.2835 17.5915 3.5 16.625 3.5Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14 1.75V5.25"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7 1.75V5.25"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2.625 8.75H18.375"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderClock = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 6V12L16 14"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderPencil = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 15 14" fill="none">
      <Rect
        x={9.68701}
        y={2.31274}
        width={3.5353}
        height={8.83825}
        transform="rotate(45 9.68701 2.31274)"
        fill={color}
      />
      <Path
        d="M2.81299 9.1875L5.31282 11.6873L2.18803 12.3123L2.81299 9.1875Z"
        fill={color}
      />
      <Rect
        x={11.562}
        y={0.437988}
        width={3.5353}
        height={1.76765}
        transform="rotate(45 11.562 0.437988)"
        fill={color}
      />
    </Svg>
  );
};

const renderCamera = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 25 24" fill="none">
      <G clipPath="url(#clip0_358_4420)">
        <Path
          d="M23.25 19C23.25 19.5304 23.0393 20.0391 22.6642 20.4142C22.2891 20.7893 21.7804 21 21.25 21H3.25C2.71957 21 2.21086 20.7893 1.83579 20.4142C1.46071 20.0391 1.25 19.5304 1.25 19V8C1.25 7.46957 1.46071 6.96086 1.83579 6.58579C2.21086 6.21071 2.71957 6 3.25 6H7.25L9.25 3H15.25L17.25 6H21.25C21.7804 6 22.2891 6.21071 22.6642 6.58579C23.0393 6.96086 23.25 7.46957 23.25 8V19Z"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M12.25 17C14.4591 17 16.25 15.2091 16.25 13C16.25 10.7909 14.4591 9 12.25 9C10.0409 9 8.25 10.7909 8.25 13C8.25 15.2091 10.0409 17 12.25 17Z"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_358_4420">
          <Rect
            width={24}
            height={24}
            fill="white"
            transform="translate(0.25)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

const renderFile = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 25 24" fill="none">
      <Path
        d="M14.75 2H6.75C6.21957 2 5.71086 2.21071 5.33579 2.58579C4.96071 2.96086 4.75 3.46957 4.75 4V20C4.75 20.5304 4.96071 21.0391 5.33579 21.4142C5.71086 21.7893 6.21957 22 6.75 22H18.75C19.2804 22 19.7891 21.7893 20.1642 21.4142C20.5393 21.0391 20.75 20.5304 20.75 20V8L14.75 2Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14.75 2V8H20.75"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.75 13H8.75"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.75 17H8.75"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10.75 9H9.75H8.75"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderPicture = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24">
      <Path
        d="M0 4.5c0 -1.655 1.345 -3 3 -3h18c1.655 0 3 1.345 3 3v15c0 1.655 -1.345 3 -3 3H3c-1.655 0 -3 -1.345 -3 -3V4.5zm15.178 4.992c-0.211 -0.309 -0.558 -0.492 -0.928 -0.492s-0.722 0.183 -0.928 0.492l-4.078 5.981 -1.242 -1.552c-0.216 -0.267 -0.539 -0.422 -0.877 -0.422s-0.666 0.155 -0.877 0.422l-3 3.75c-0.272 0.338 -0.323 0.802 -0.136 1.191S3.694 19.5 4.125 19.5h15.75c0.417 0 0.802 -0.23 0.994 -0.6s0.169 -0.816 -0.066 -1.158l-5.625 -8.25zM5.25 9a2.25 2.25 0 1 0 0 -4.5 2.25 2.25 0 1 0 0 4.5z"
        fill={color}
      />
    </Svg>
  );
};

const renderListItemNav = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 12 20" fill="none">
      <Path
        d="M1 1.5L10 10L1 18.5"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
      />
    </Svg>
  );
};

const renderMeetingNotes = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderClose = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15 9L9 15"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M9 9L15 15"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderChecked = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 14 14" fill="none">
      <Path
        d="M11.6668 3.5L5.25016 9.91667L2.3335 7"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderTaskCheck = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 25" fill="none">
      <Path
        d="M9 11.5L12 14.5L22 4.5"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M21 12.5V19.5C21 20.0304 20.7893 20.5391 20.4142 20.9142C20.0391 21.2893 19.5304 21.5 19 21.5H5C4.46957 21.5 3.96086 21.2893 3.58579 20.9142C3.21071 20.5391 3 20.0304 3 19.5V5.5C3 4.96957 3.21071 4.46086 3.58579 4.08579C3.96086 3.71071 4.46957 3.5 5 3.5H16"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderSiteInspection = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.5 13C16.5 16.5 12 19.5 12 19.5C12 19.5 7.5 16.5 7.5 13C7.5 11.8065 7.97411 10.6619 8.81802 9.81802C9.66193 8.97411 10.8065 8.5 12 8.5C13.1935 8.5 14.3381 8.97411 15.182 9.81802C16.0259 10.6619 16.5 11.8065 16.5 13Z"
        fill={color}
      />
      <Path
        d="M12 14.5C12.8284 14.5 13.5 13.8284 13.5 13C13.5 12.1716 12.8284 11.5 12 11.5C11.1716 11.5 10.5 12.1716 10.5 13C10.5 13.8284 11.1716 14.5 12 14.5Z"
        fill="#FCFEFE"
      />
    </Svg>
  );
};

const renderEye = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill={color}>
      <Path d="M0 0h24v24H0V0z" fill="none" />
      <Path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
    </Svg>
  );
};

const renderEyeSlash = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill={color}>
      <Path
        d="M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
        fill="none"
      />
      <Path d="M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z" />
    </Svg>
  );
};

const renderTrash = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 20 20" fill="none">
      <Path
        d="M2.5 5H4.16667H17.5"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6.6665 4.99996V3.33329C6.6665 2.89127 6.8421 2.46734 7.15466 2.15478C7.46722 1.84222 7.89114 1.66663 8.33317 1.66663H11.6665C12.1085 1.66663 12.5325 1.84222 12.845 2.15478C13.1576 2.46734 13.3332 2.89127 13.3332 3.33329V4.99996M15.8332 4.99996V16.6666C15.8332 17.1087 15.6576 17.5326 15.345 17.8451C15.0325 18.1577 14.6085 18.3333 14.1665 18.3333H5.83317C5.39114 18.3333 4.96722 18.1577 4.65466 17.8451C4.3421 17.5326 4.1665 17.1087 4.1665 16.6666V4.99996H15.8332Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8.3335 9.16663V14.1666"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M11.6665 9.16663V14.1666"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderDownload = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 640 512" fill={color}>
      <Path d="M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z" />
    </Svg>
  );
};

const renderClipboard = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderCompass = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 512 512">
      <Path
        fill={color}
        d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
      />
    </Svg>
  );
};

const renderTraining = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 25" fill="none">
      <G clipPath="url(#clip0_5427_5938)">
        <Path
          d="M5 13.0702L11.0771 15.9062L11.5 16.1035L11.9229 15.9062L18 13.0702V18.8669C17.7802 19.0303 17.4201 19.2641 16.8963 19.5037C15.8463 19.9843 14.1141 20.5 11.5 20.5C8.88586 20.5 7.15368 19.9843 6.10365 19.5037C5.57995 19.2641 5.2198 19.0303 5 18.8669V13.0702Z"
          stroke={color}
          strokeWidth={2}
        />
        <Path
          d="M1 10.25L11.625 4.63367L22.25 10.25L11.625 15.8663L1 10.25Z"
          stroke={color}
          strokeWidth={2}
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_5427_5938">
          <Rect
            width={24}
            height={24}
            fill="white"
            transform="translate(0 0.5)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

const renderTrainingBreakdown = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 512 512">
      <Path
        fill={color}
        d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z"
      />
    </Svg>
  );
};

const renderCertification = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8.21 13.8899L7 22.9999L12 19.9999L17 22.9999L15.79 13.8799"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderUserPlus = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8.5 11C10.7091 11 12.5 9.20914 12.5 7C12.5 4.79086 10.7091 3 8.5 3C6.29086 3 4.5 4.79086 4.5 7C4.5 9.20914 6.29086 11 8.5 11Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20 8V14"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M23 11H17"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderVehicle = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M16 3H1V16H16V3Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16 8H20L23 11V16H16V8Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5.5 21C6.88071 21 8 19.8807 8 18.5C8 17.1193 6.88071 16 5.5 16C4.11929 16 3 17.1193 3 18.5C3 19.8807 4.11929 21 5.5 21Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M18.5 21C19.8807 21 21 19.8807 21 18.5C21 17.1193 19.8807 16 18.5 16C17.1193 16 16 17.1193 16 18.5C16 19.8807 17.1193 21 18.5 21Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderMaintanence = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 25" fill="none">
      <Path
        d="M14.7 6.80022C14.5168 6.98715 14.4141 7.23847 14.4141 7.50022C14.4141 7.76198 14.5168 8.0133 14.7 8.20022L16.3 9.80022C16.4869 9.98345 16.7382 10.0861 17 10.0861C17.2617 10.0861 17.513 9.98345 17.7 9.80022L21.47 6.03022C21.9728 7.14141 22.1251 8.37946 21.9064 9.57937C21.6878 10.7793 21.1087 11.8841 20.2463 12.7465C19.3838 13.6089 18.279 14.1881 17.0791 14.4067C15.8792 14.6253 14.6412 14.4731 13.53 13.9702L6.61998 20.8802C6.22215 21.278 5.68259 21.5015 5.11998 21.5015C4.55737 21.5015 4.0178 21.278 3.61998 20.8802C3.22215 20.4824 2.99866 19.9428 2.99866 19.3802C2.99866 18.8176 3.22215 18.278 3.61998 17.8802L10.53 10.9702C10.0271 9.85904 9.87489 8.62099 10.0935 7.42108C10.3121 6.22117 10.8913 5.11638 11.7537 4.25395C12.6161 3.39151 13.7209 2.81239 14.9208 2.59377C16.1207 2.37514 17.3588 2.52739 18.47 3.03022L14.71 6.79022L14.7 6.80022Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderFirstAid = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M20.84 4.60987C20.3292 4.09888 19.7228 3.69352 19.0554 3.41696C18.3879 3.14039 17.6725 2.99805 16.95 2.99805C16.2275 2.99805 15.5121 3.14039 14.8446 3.41696C14.1772 3.69352 13.5708 4.09888 13.06 4.60987L12 5.66987L10.94 4.60987C9.9083 3.57818 8.50903 2.99858 7.05 2.99858C5.59096 2.99858 4.19169 3.57818 3.16 4.60987C2.1283 5.64156 1.54871 7.04084 1.54871 8.49987C1.54871 9.95891 2.1283 11.3582 3.16 12.3899L4.22 13.4499L12 21.2299L19.78 13.4499L20.84 12.3899C21.351 11.8791 21.7563 11.2727 22.0329 10.6052C22.3095 9.93777 22.4518 9.22236 22.4518 8.49987C22.4518 7.77738 22.3095 7.06198 22.0329 6.39452C21.7563 5.72706 21.351 5.12063 20.84 4.60987V4.60987Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <G clipPath="url(#clip0_5737_9476)">
        <Path
          d="M17.8333 11H15.5L13.75 14.75L10.25 7.25L8.49996 11H6.16663"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_5737_9476">
          <Rect
            width={14}
            height={10}
            fill="white"
            transform="translate(5 6)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

const renderInputSearch = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 25 24" fill="none">
      <Path
        d="M11.5 19C15.9183 19 19.5 15.4183 19.5 11C19.5 6.58172 15.9183 3 11.5 3C7.08172 3 3.5 6.58172 3.5 11C3.5 15.4183 7.08172 19 11.5 19Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M21.5 20.9999L17.15 16.6499"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderInputClear = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 14 14" fill="none">
      <G clipPath="url(#clip0_57_382)">
        <Path
          d="M6.99984 12.8333C10.2215 12.8333 12.8332 10.2217 12.8332 7.00001C12.8332 3.77834 10.2215 1.16667 6.99984 1.16667C3.77818 1.16667 1.1665 3.77834 1.1665 7.00001C1.1665 10.2217 3.77818 12.8333 6.99984 12.8333Z"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M8.75 5.25L5.25 8.75"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M5.25 5.25L8.75 8.75"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_57_382">
          <Rect width={14} height={14} fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

const renderInputCheck = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 14 14" fill="none">
      <Path
        d="M11.6668 3.5L5.25016 9.91667L2.3335 7"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderInputFilters = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 17 16" fill="none">
      <G clipPath="url(#clip0_4677_10312)">
        <Path
          d="M2.49996 2.66675L7.16663 2.66675"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M9.83333 2.66675L14.5 2.66675"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M2.5 8L8.5 8"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M11.1667 8L14.5 8"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M2.50004 13.3333L5.83337 13.3333"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M8.5 13.3333L14.5 13.3333"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M7.16663 0.666748L7.16663 4.66675"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M11.1666 6L11.1666 10"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M5.83337 11.3333L5.83337 15.3333"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_4677_10312">
          <Rect
            width={16}
            height={16}
            fill="white"
            transform="translate(16.5) rotate(90)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

const renderHazard = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        d="M13 2L3 14H12L11 22L21 10H12L13 2Z"
        fill={color}
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderInjury = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5 5.50011C17.9872 3.98733 15.5345 3.98733 14.0217 5.50011L5.50002 14.0218C3.98725 15.5346 3.98725 17.9873 5.50002 19.5001C7.0128 21.0129 9.46549 21.0129 10.9783 19.5001L11.8913 18.587L6.4131 13.1088L13.1087 6.41314L18.587 11.8914L19.5 10.9784C21.0128 9.46558 21.0128 7.01289 19.5 5.50011Z"
        fill={color}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 7.02173L17.9782 12.5L12.5 17.9782L7.02175 12.5L12.5 7.02173ZM12.8043 9.15216C12.6363 9.32025 12.3637 9.32025 12.1957 9.15216C12.0276 8.98408 12.0276 8.71155 12.1957 8.54347C12.3637 8.37538 12.6363 8.37538 12.8043 8.54347C12.9724 8.71155 12.9724 8.98408 12.8043 9.15216ZM13.413 10.3695C13.5811 10.5376 13.8536 10.5376 14.0217 10.3695C14.1898 10.2015 14.1898 9.92893 14.0217 9.76084C13.8536 9.59276 13.5811 9.59276 13.413 9.76084C13.2449 9.92893 13.2449 10.2015 13.413 10.3695ZM15.2391 11.5869C15.071 11.755 14.7985 11.755 14.6304 11.5869C14.4624 11.4188 14.4624 11.1463 14.6304 10.9782C14.7985 10.8101 15.071 10.8101 15.2391 10.9782C15.4072 11.1463 15.4072 11.4188 15.2391 11.5869ZM15.8478 12.8043C16.0159 12.9724 16.2884 12.9724 16.4565 12.8043C16.6246 12.6362 16.6246 12.3637 16.4565 12.1956C16.2884 12.0275 16.0159 12.0275 15.8478 12.1956C15.6797 12.3637 15.6797 12.6362 15.8478 12.8043ZM11.587 10.3695C11.4189 10.5376 11.1464 10.5376 10.9783 10.3695C10.8102 10.2015 10.8102 9.92893 10.9783 9.76084C11.1464 9.59276 11.4189 9.59276 11.587 9.76084C11.7551 9.92893 11.7551 10.2015 11.587 10.3695ZM12.1956 11.5869C12.3637 11.755 12.6363 11.755 12.8043 11.5869C12.9724 11.4188 12.9724 11.1463 12.8043 10.9782C12.6363 10.8101 12.3637 10.8101 12.1956 10.9782C12.0276 11.1463 12.0276 11.4188 12.1956 11.5869ZM14.0218 12.8043C13.8537 12.9724 13.5811 12.9724 13.4131 12.8043C13.245 12.6362 13.245 12.3637 13.4131 12.1956C13.5811 12.0275 13.8537 12.0275 14.0218 12.1956C14.1898 12.3637 14.1898 12.6362 14.0218 12.8043ZM14.6304 14.0217C14.7985 14.1898 15.071 14.1898 15.2391 14.0217C15.4072 13.8536 15.4072 13.5811 15.2391 13.413C15.071 13.2449 14.7985 13.2449 14.6304 13.413C14.4623 13.5811 14.4623 13.8536 14.6304 14.0217ZM10.3696 11.5869C10.2015 11.755 9.92897 11.755 9.76088 11.5869C9.59279 11.4188 9.59279 11.1463 9.76088 10.9782C9.92897 10.8101 10.2015 10.8101 10.3696 10.9782C10.5377 11.1463 10.5377 11.4188 10.3696 11.5869ZM10.9782 12.8043C11.1463 12.9724 11.4188 12.9724 11.5869 12.8043C11.755 12.6362 11.755 12.3637 11.5869 12.1956C11.4188 12.0275 11.1463 12.0275 10.9782 12.1956C10.8101 12.3637 10.8101 12.6362 10.9782 12.8043ZM12.8043 14.0217C12.6362 14.1898 12.3637 14.1898 12.1956 14.0217C12.0275 13.8536 12.0275 13.5811 12.1956 13.413C12.3637 13.2449 12.6362 13.2449 12.8043 13.413C12.9724 13.5811 12.9724 13.8536 12.8043 14.0217ZM13.413 15.2391C13.5811 15.4072 13.8536 15.4072 14.0217 15.2391C14.1898 15.071 14.1898 14.7985 14.0217 14.6304C13.8536 14.4623 13.5811 14.4623 13.413 14.6304C13.2449 14.7985 13.2449 15.071 13.413 15.2391ZM9.15221 12.8043C8.98412 12.9724 8.7116 12.9724 8.54352 12.8043C8.37543 12.6362 8.37543 12.3637 8.54352 12.1956C8.7116 12.0275 8.98412 12.0275 9.15221 12.1956C9.3203 12.3637 9.3203 12.6362 9.15221 12.8043ZM9.7609 14.0217C9.92899 14.1898 10.2015 14.1898 10.3696 14.0217C10.5377 13.8536 10.5377 13.5811 10.3696 13.413C10.2015 13.2449 9.92899 13.2449 9.7609 13.413C9.59281 13.5811 9.59281 13.8536 9.7609 14.0217ZM11.587 15.2391C11.4189 15.4072 11.1464 15.4072 10.9783 15.2391C10.8102 15.071 10.8102 14.7985 10.9783 14.6304C11.1464 14.4623 11.4189 14.4623 11.587 14.6304C11.7551 14.7985 11.7551 15.071 11.587 15.2391ZM12.1957 16.4565C12.3638 16.6246 12.6363 16.6246 12.8044 16.4565C12.9725 16.2884 12.9725 16.0159 12.8044 15.8478C12.6363 15.6797 12.3638 15.6797 12.1957 15.8478C12.0276 16.0159 12.0276 16.2884 12.1957 16.4565Z"
        fill={color}
      />
    </Svg>
  );
};

const renderNearMiss = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 8.59808L15.3299 8.30348C15.2615 8.20001 15.1914 8.09876 15.1197 8.00001H15.1547L14 6L16 4.8453V4.83395L16.0074 4.84101L17.4641 4L18.9641 6.59808L17.8939 7.21594C19.2017 9.34602 20 11.9141 20 14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14C4 11.9191 4.79449 9.35831 6.09668 7.23125L5.00001 6.59808L6.50001 4.00001L7.97904 4.85392L8 4.83395V4.86603L9.96411 6.00001L8.80941 8.00001H8.88029C7.73418 9.57836 7 11.7951 7 13.5263C7 16.5494 9.23858 19 12 19C14.7614 19 17 16.5494 17 13.5263C17 12.0019 16.4307 10.101 15.5122 8.59101L15.5 8.59808ZM16 18.5C16 18.7761 16.2239 19 16.5 19C16.7761 19 17 18.7761 17 18.5C17 18.2239 16.7761 18 16.5 18C16.2239 18 16 18.2239 16 18.5ZM7.5 18C7.22386 18 7 18.2239 7 18.5C7 18.7761 7.22386 19 7.5 19C7.77614 19 8 18.7761 8 18.5C8 18.2239 7.77614 18 7.5 18ZM7 9.5C7 9.77614 6.77614 10 6.5 10C6.22386 10 6 9.77614 6 9.5C6 9.22386 6.22386 9 6.5 9C6.77614 9 7 9.22386 7 9.5ZM17.5 10C17.7761 10 18 9.77614 18 9.5C18 9.22386 17.7761 9 17.5 9C17.2239 9 17 9.22386 17 9.5C17 9.77614 17.2239 10 17.5 10ZM19 13.5C19 13.7761 18.7761 14 18.5 14C18.2239 14 18 13.7761 18 13.5C18 13.2239 18.2239 13 18.5 13C18.7761 13 19 13.2239 19 13.5ZM5.5 14C5.77614 14 6 13.7761 6 13.5C6 13.2239 5.77614 13 5.5 13C5.22386 13 5 13.2239 5 13.5C5 13.7761 5.22386 14 5.5 14Z"
        fill={color}
      />
    </Svg>
  );
};

const renderBear = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 25 24" fill="none">
      <Path
        d="M3.66242 6.40908C0.668791 7.5013 0.716562 11.4151 1.11465 13.2355C1.29348 14.6008 0.636943 15.8902 0.318471 16.2694C0 16.6487 -0.0796178 17.4072 0.0796178 18.014C0.207006 18.4994 0.822719 18.8736 1.11465 19H3.42357C3.34395 18.8483 3.15287 18.4994 3.02548 18.3174C2.86624 18.0898 2.46815 18.5449 2.14968 18.3174C1.8949 18.1353 2.04352 17.7864 2.14968 17.6347L3.42357 16.4211L5.25478 19H8.51911C8.51911 18.8483 8.43949 18.4994 8.12102 18.3174C7.80255 18.1353 7.35138 18.2415 7.16561 18.3174C6.95329 18.0645 6.46497 17.4072 6.21019 16.8004C5.95541 16.1936 5.73248 14.4743 5.65287 13.6906C6.26327 13.9181 7.69108 14.3732 8.51911 14.3732C9.34713 14.3732 10.4565 13.817 10.9076 13.5389C10.8546 13.9687 10.7325 14.9648 10.6688 15.5109C10.5892 16.1936 10.9076 16.4211 11.1465 17.0279C11.3376 17.5134 11.4384 18.5449 11.465 19H14.4108C14.4108 18.8483 14.3471 18.4994 14.0924 18.3174C13.7739 18.0898 13.2166 18.3174 12.8981 18.0898C12.5796 17.8623 12.8185 17.483 13.2166 16.4211C13.535 15.5716 14.3577 14.2468 14.7293 13.6906C14.8089 13.9434 15.0796 14.6159 15.5255 15.2834C16.0828 16.1177 18.1529 17.7864 18.8694 18.014C19.4427 18.196 20.0106 18.7472 20.2229 19H23.1688C23.2484 18.8483 23.328 18.4994 23.0096 18.3174C22.6115 18.0898 22.1338 18.1657 21.4172 18.0898C20.7006 18.014 20.9395 17.5589 20.5414 17.0279C20.1433 16.497 19.3471 15.5868 19.0287 15.2834C18.7102 14.98 17.914 13.2355 17.914 12.2494C17.914 11.2634 19.7452 11.2634 20.5414 11.1876C21.3376 11.1117 22.1338 11.5668 23.0096 11.6427C23.8854 11.7185 25 10.8842 25 10.7325C25 10.5808 23.8854 9.59473 23.6465 9.36719C23.4076 9.13964 23.4873 8.53285 23.4076 8.3053C23.328 8.07776 22.2134 7.54681 22.1338 7.16757C22.0541 6.78832 22.1338 6.40908 21.8153 6.40908H20.5414C19.931 6.40908 18.3917 6.21187 17.1178 5.42304C15.5255 4.43701 14.0127 5.42304 13.2166 5.87814C12.4204 6.33323 10.2707 5.87814 8.83758 5.42304C7.40446 4.96795 7.40446 5.0438 3.66242 6.40908Z"
        fill={color}
      />
    </Svg>
  );
};

const renderPropertyDamage = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0014 3.00087L12 3L4 8V21H10V15H14V21H20V8.41871L18.9787 8.07899L18.6904 10.757L17 8.66L15.3096 10.757L15.0213 8.07899L12.4655 8.92916L13.6707 6.52042L11.0611 5.85389L13.3773 4.47913L12.0014 3.00087Z"
        fill={color}
      />
    </Svg>
  );
};

const renderMore = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Circle cx={3} cy={12} r={3} fill={color} />
      <Circle cx={12} cy={12} r={3} fill={color} />
      <Circle cx={21} cy={12} r={3} fill={color} />
    </Svg>
  );
};

const renderCloseCircle = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      />
      <Path
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 9L9 15"
      />
      <Path
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 9L15 15"
      />
    </Svg>
  );
};

const renderHarassment = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 12C20 16.4183 16.4183 20 12 20C10.5937 20 9.27224 19.6372 8.12399 19C7.5 19 4 20 4 20C4 20 5 16.5 5.07026 16C4.38958 14.8233 4 13.4571 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM13 6V14H11V6H13ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
        fill={color}
      />
    </Svg>
  );
};

const renderAdd = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <G clipPath="url(#clip0_5579_3175)">
        <Path
          d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M12 8V16"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M8 12H16"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_5579_3175">
          <Rect width={24} height={24} fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

//From https://fonts.google.com/icons?selected=Material+Symbols+Outlined:export_notes:FILL@0;wght@400;GRAD@0;opsz@24&icon.query=file
const renderConvert = (color: ColorValue) => {
  return (
    <Svg viewBox="0 -960 960 960" height={24} width={24} fill={color}>
      <Path d="m648-140 112-112v92h40v-160H640v40h92L620-168l28 28Zm-448 20q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v268q-19-9-39-15.5t-41-9.5v-243H200v560h242q3 22 9.5 42t15.5 38H200Zm0-120v40-560 243-3 280Zm80-40h163q3-21 9.5-41t14.5-39H280v80Zm0-160h244q32-30 71.5-50t84.5-27v-3H280v80Zm0-160h400v-80H280v80ZM720-40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40Z" />
    </Svg>
  );
};

//From https://fontawesome.com/icons/chevron-down?f=classic&s=solid
const renderArrowDown = (color: ColorValue) => {
  return (
    <Svg fill={color} viewBox="0 0 512 512">
      <Path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
    </Svg>
  );
};

//From https://fontawesome.com/icons/chevron-down?f=classic&s=solid
const renderArrowUp = (color: ColorValue) => {
  return (
    <Svg fill={color} viewBox="0 0 512 512">
      <Path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
    </Svg>
  );
};

//From https://fontawesome.com/
const renderCollapse = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" stroke={color} fill={color}>
      <Path d="M10.941 4.941c0.586 -0.586 1.537 -0.586 2.123 0l9 9c0.586 0.586 0.586 1.537 0 2.123s-1.537 0.586 -2.123 0L12 8.123 4.059 16.059c-0.586 0.586 -1.537 0.586 -2.123 0s-0.586 -1.537 0 -2.123l9 -9z" />
    </Svg>
  );
};

//From https://fontawesome.com/
const renderExpand = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" stroke={color} fill={color}>
      <Path d="M10.941 19.059c0.586 0.586 1.537 0.586 2.123 0l9 -9c0.586 -0.586 0.586 -1.537 0 -2.123s-1.537 -0.586 -2.123 0L12 15.877 4.059 7.941c-0.586 -0.586 -1.537 -0.586 -2.123 0s-0.586 1.537 0 2.123l9 9z" />
    </Svg>
  );
};

const renderPeopleList = (color: ColorValue) => {
  return (
    <Svg
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round">
      <Path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <Circle cx={9} cy={7} r={4} />
      <Path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <Path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </Svg>
  );
};

const renderProjectsSites = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 25 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2572 8.89308C13.6104 8.89308 14.7074 7.83328 14.7074 6.52596C14.7074 5.21864 13.6104 4.15885 12.2572 4.15885C10.9041 4.15885 9.80708 5.21864 9.80708 6.52596C9.80708 7.83328 10.9041 8.89308 12.2572 8.89308ZM12.2572 7.94623C11.4453 7.94623 10.7871 7.31036 10.7871 6.52596C10.7871 5.74157 11.4453 5.10569 12.2572 5.10569C13.0691 5.10569 13.7273 5.74157 13.7273 6.52596C13.7273 7.31036 13.0691 7.94623 12.2572 7.94623Z"
        fill={color}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7701 6.67391C17.7701 8.32394 16.9533 9.83921 16.0036 11.0498L16.387 11.2208L19.6174 10.2845C20.299 10.0869 21.0109 10.4902 21.1653 11.1614L23.2684 20.3044C23.2758 20.3366 23.2803 20.3688 23.2821 20.4007C23.3149 20.4482 23.341 20.5011 23.3588 20.5586C23.456 20.8717 23.2721 21.2016 22.9481 21.2955L18.1178 22.6955C18.0407 22.7469 17.9503 22.7819 17.8511 22.7947C17.7568 22.8068 17.6647 22.7976 17.5799 22.7708C17.4908 22.7646 17.4021 22.749 17.3156 22.7239L12.5551 21.3442L7.27853 22.7345C7.05737 22.7927 6.82373 22.7899 6.60416 22.7262L1.66765 21.2955C1.35929 21.2061 1.17786 20.903 1.2448 20.6041L2.95879 11.2207C3.0862 10.5232 3.81501 10.0892 4.51725 10.2928L7.72834 11.2234L8.42265 10.936C7.51118 9.74479 6.74438 8.27261 6.74438 6.67391C6.74438 5.2279 7.32076 3.83759 8.35245 2.80972C9.38475 1.78124 10.7889 1.19995 12.2572 1.19995C13.7255 1.19995 15.1297 1.78124 16.162 2.80972C17.1937 3.83759 17.7701 5.2279 17.7701 6.67391ZM2.54195 20.3132L6.18405 21.3688L7.10648 12.2789L4.16523 11.4264L2.54195 20.3132ZM7.40427 21.4745L11.6447 20.3573V14.0272C11.5068 13.9273 11.3212 13.7886 11.1028 13.6154C10.6277 13.2385 9.99282 12.694 9.35599 12.0242C9.31393 11.98 9.27174 11.9351 9.22949 11.8896L8.33955 12.258L7.40427 21.4745ZM12.8698 20.2003C12.8823 20.2035 12.8947 20.2069 12.9071 20.2105L17.0418 21.4089L15.7782 12.2529L15.1903 11.9907L15.1585 12.0242C14.5217 12.694 13.8868 13.2385 13.4116 13.6154C13.1933 13.7886 13.0077 13.9273 12.8698 14.0272V20.2003ZM18.2784 21.4133L22.0191 20.3291L19.9694 11.4181L17.017 12.2738L18.2784 21.4133ZM9.23193 3.63365C10.0376 2.83096 11.1262 2.38351 12.2572 2.38351C13.3882 2.38351 14.4769 2.83096 15.2825 3.63365C16.0888 4.43696 16.545 5.53025 16.545 6.67391C16.545 8.14912 15.6924 9.58776 14.6654 10.7733C14.5811 10.8294 14.5104 10.9066 14.4627 11.0016C14.3944 11.0767 14.3255 11.1507 14.2563 11.2235C13.6681 11.8422 13.0779 12.3487 12.6342 12.7007C12.4911 12.8142 12.3638 12.9113 12.2572 12.9904C12.1507 12.9113 12.0234 12.8142 11.8803 12.7007C11.4366 12.3487 10.8464 11.8422 10.2582 11.2235C9.05882 9.96225 7.96946 8.34144 7.96946 6.67391C7.96946 5.53025 8.42564 4.43696 9.23193 3.63365Z"
        fill={color}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2572 8.89308C13.6104 8.89308 14.7074 7.83328 14.7074 6.52596C14.7074 5.21864 13.6104 4.15885 12.2572 4.15885C10.9041 4.15885 9.80708 5.21864 9.80708 6.52596C9.80708 7.83328 10.9041 8.89308 12.2572 8.89308ZM12.2572 7.94623C11.4453 7.94623 10.7871 7.31036 10.7871 6.52596C10.7871 5.74157 11.4453 5.10569 12.2572 5.10569C13.0691 5.10569 13.7273 5.74157 13.7273 6.52596C13.7273 7.31036 13.0691 7.94623 12.2572 7.94623Z"
        stroke={color}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7701 6.67391C17.7701 8.32394 16.9533 9.83921 16.0036 11.0498L16.387 11.2208L19.6174 10.2845C20.299 10.0869 21.0109 10.4902 21.1653 11.1614L23.2684 20.3044C23.2758 20.3366 23.2803 20.3688 23.2821 20.4007C23.3149 20.4482 23.341 20.5011 23.3588 20.5586C23.456 20.8717 23.2721 21.2016 22.9481 21.2955L18.1178 22.6955C18.0407 22.7469 17.9503 22.7819 17.8511 22.7947C17.7568 22.8068 17.6647 22.7976 17.5799 22.7708C17.4908 22.7646 17.4021 22.749 17.3156 22.7239L12.5551 21.3442L7.27853 22.7345C7.05737 22.7927 6.82373 22.7899 6.60416 22.7262L1.66765 21.2955C1.35929 21.2061 1.17786 20.903 1.2448 20.6041L2.95879 11.2207C3.0862 10.5232 3.81501 10.0892 4.51725 10.2928L7.72834 11.2234L8.42265 10.936C7.51118 9.74479 6.74438 8.27261 6.74438 6.67391C6.74438 5.2279 7.32076 3.83759 8.35245 2.80972C9.38475 1.78124 10.7889 1.19995 12.2572 1.19995C13.7255 1.19995 15.1297 1.78124 16.162 2.80972C17.1937 3.83759 17.7701 5.2279 17.7701 6.67391ZM2.54195 20.3132L6.18405 21.3688L7.10648 12.2789L4.16523 11.4264L2.54195 20.3132ZM7.40427 21.4745L11.6447 20.3573V14.0272C11.5068 13.9273 11.3212 13.7886 11.1028 13.6154C10.6277 13.2385 9.99282 12.694 9.35599 12.0242C9.31393 11.98 9.27174 11.9351 9.22949 11.8896L8.33955 12.258L7.40427 21.4745ZM12.8698 20.2003C12.8823 20.2035 12.8947 20.2069 12.9071 20.2105L17.0418 21.4089L15.7782 12.2529L15.1903 11.9907L15.1585 12.0242C14.5217 12.694 13.8868 13.2385 13.4116 13.6154C13.1933 13.7886 13.0077 13.9273 12.8698 14.0272V20.2003ZM18.2784 21.4133L22.0191 20.3291L19.9694 11.4181L17.017 12.2738L18.2784 21.4133ZM9.23193 3.63365C10.0376 2.83096 11.1262 2.38351 12.2572 2.38351C13.3882 2.38351 14.4769 2.83096 15.2825 3.63365C16.0888 4.43696 16.545 5.53025 16.545 6.67391C16.545 8.14912 15.6924 9.58776 14.6654 10.7733C14.5811 10.8294 14.5104 10.9066 14.4627 11.0016C14.3944 11.0767 14.3255 11.1507 14.2563 11.2235C13.6681 11.8422 13.0779 12.3487 12.6342 12.7007C12.4911 12.8142 12.3638 12.9113 12.2572 12.9904C12.1507 12.9113 12.0234 12.8142 11.8803 12.7007C11.4366 12.3487 10.8464 11.8422 10.2582 11.2235C9.05882 9.96225 7.96946 8.34144 7.96946 6.67391C7.96946 5.53025 8.42564 4.43696 9.23193 3.63365Z"
        stroke={color}
      />
    </Svg>
  );
};

const renderLogout = (color: ColorValue) => {
  return (
    <Svg
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round">
      <Path stroke={color} d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <Polyline points="16 17 21 12 16 7" />
      <Line x1={21} y1={12} x2={9} y2={12} />
    </Svg>
  );
};

const renderLibrary = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 25 24" fill="none">
      <Path
        d="M4.5 19.5C4.5 18.837 4.76339 18.2011 5.23223 17.7322C5.70107 17.2634 6.33696 17 7 17H20.5"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7 2H20.5V22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2V2Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const renderFolder = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill={color}>
      <Path d="M0 4.5c0 -1.655 1.345 -3 3 -3h6.192c0.895 0 1.753 0.356 2.386 0.989L13.589 4.5H21c1.655 0 3 1.345 3 3v12c0 1.655 -1.345 3 -3 3H3c-1.655 0 -3 -1.345 -3 -3zm3 -0.75c-0.413 0 -0.75 0.338 -0.75 0.75v15c0 0.413 0.338 0.75 0.75 0.75h18c0.413 0 0.75 -0.338 0.75 -0.75V7.5c0 -0.413 -0.338 -0.75 -0.75 -0.75H13.434c-0.497 0 -0.975 -0.197 -1.327 -0.548L9.989 4.078c-0.211 -0.211 -0.497 -0.328 -0.797 -0.328z" />
    </Svg>
  );
};

const renderPrint = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill={color}>
      <Path d="M6 0C4.345 0 3 1.345 3 3v4.5h3V3h10.627L18 4.373V7.5h3V4.373c0 -0.797 -0.314 -1.561 -0.877 -2.123L18.75 0.877C18.188 0.314 17.423 0 16.627 0zm12 16.5v4.5H6v-4.5zm3 1.5h1.5c0.83 0 1.5 -0.67 1.5 -1.5v-4.5c0 -1.655 -1.345 -3 -3 -3H3c-1.655 0 -3 1.345 -3 3v4.5c0 0.83 0.67 1.5 1.5 1.5h1.5v3c0 1.655 1.345 3 3 3h12c1.655 0 3 -1.345 3 -3zm-0.75 -6.375a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 1 1 0 -2.25" />
    </Svg>
  );
};

const renderAudit = (color: ColorValue) => {
  return (
    <Svg viewBox="0 -960 960 960" fill={color}>
      <Path d="M160-120q-33 0-56.5-23.5T80-200v-560q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v560q0 33-23.5 56.5T800-120H160Zm0-80h640v-560H160v560Zm40-80h200v-80H200v80Zm382-80 198-198-57-57-141 142-57-57-56 57 113 113Zm-382-80h200v-80H200v80Zm0-160h200v-80H200v80Zm-40 400v-560 560Z" />
    </Svg>
  );
};

const renderQuickAdd = (color: ColorValue) => {
  return (
    <Svg>
      <Defs>
        <ClipPath id="a">
          <Path
            id="svg_1"
            d="m0.994,0.751l12.87,0l0,12.87l-12.87,0l0,-12.87zm0,0"
          />
        </ClipPath>
        <ClipPath id="b">
          <Path
            id="svg_2"
            d="m7.43,0.751a6.436,6.436 0 1 0 0.002,12.868a6.436,6.436 0 0 0 -0.002,-12.867l0,-0.001zm0,0"
          />
        </ClipPath>
        <ClipPath id="c">
          <Path id="svg_3" d="m7.04,6.28l4.88,0l0,5.2l-4.88,0l0,-5.2zm0,0" />
        </ClipPath>
        <ClipPath id="d">
          <Path
            id="svg_4"
            d="m7.059,11.475l-2.421,-3.543l4.827,-3.298l2.421,3.543l-4.827,3.298zm0,0"
          />
        </ClipPath>
        <ClipPath id="e">
          <Path
            id="svg_5"
            d="m7.052,6.282l0.008,5.192l1.772,-1.21l1.283,-0.877l1.772,-1.21l-4.835,-1.895zm0,0"
          />
        </ClipPath>
        <ClipPath id="f">
          <Path id="svg_6" d="m8.262,8.054l6,0l0,6l-6,0l0,-6zm0,0" />
        </ClipPath>
      </Defs>
      <G>
        <G stroke="none" id="svg_16">
          <G
            stroke="none"
            id="svg_7"
            transform="matrix(1.63311 0 0 1.65804 -0.291414 -0.30261)"
            clipPath="url(#a)">
            <G stroke="none" id="svg_8" clipPath="url(#b)">
              <Path
                stroke={color}
                id="svg_9"
                strokeWidth="3.71979px"
                d="m7.43,0.751a6.436,6.436 0 1 0 0.002,12.868a6.436,6.436 0 0 0 -0.002,-12.867l0,-0.001zm0,0"
                fill="none"
              />
            </G>
          </G>
          <G
            stroke="none"
            id="svg_10"
            transform="matrix(1.63311 0 0 1.65804 -0.291414 -0.30261)"
            clipPath="url(#c)">
            <G stroke="none" id="svg_11" clipPath="url(#d)">
              <G stroke="none" id="svg_12" clipPath="url(#e)">
                <Path
                  stroke="none"
                  id="svg_13"
                  strokeWidth="3.71979px"
                  d="m7.059,11.475l-2.421,-3.543l4.827,-3.298l2.421,3.543l-4.827,3.298zm0,0"
                  fill={color}
                />
              </G>
            </G>
          </G>
          <G
            stroke="none"
            id="svg_14"
            transform="matrix(1.63311 0 0 1.65804 -0.291414 -0.30261)"
            clipPath="url(#f)">
            <Path
              stroke="none"
              id="svg_15"
              strokeWidth="3.71979px"
              d="m10.056,8.054a4.21,4.21 0 0 0 4.206,4.206l0,1.794a6,6 0 0 1 -6,-6l1.794,0zm0,0"
              fill={color}
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};

const renderSyncing = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill={color}>
      <Path d="M6.698 6.698c2.916 -2.916 7.627 -2.93 10.561 -0.047L15.328 8.578c-0.323 0.323 -0.417 0.806 -0.244 1.228S15.67 10.5 16.125 10.5h6c0.623 0 1.125 -0.502 1.125 -1.125V3.375c0 -0.455 -0.272 -0.867 -0.694 -1.041S21.652 2.255 21.328 2.578l-1.95 1.95c-4.106 -4.055 -10.72 -4.041 -14.803 0.047 -1.144 1.144 -1.969 2.489 -2.475 3.928 -0.277 0.783 0.136 1.636 0.914 1.912s1.636 -0.136 1.912 -0.914c0.361 -1.022 0.947 -1.983 1.772 -2.803M0.75 14.625v6c0 0.455 0.272 0.867 0.694 1.041s0.905 0.08 1.228 -0.244l1.95 -1.95c4.106 4.055 10.72 4.041 14.803 -0.047 1.144 -1.144 1.973 -2.489 2.48 -3.923 0.277 -0.783 -0.136 -1.636 -0.914 -1.912s-1.636 0.136 -1.912 0.914c-0.361 1.022 -0.947 1.983 -1.772 2.803 -2.916 2.916 -7.627 2.93 -10.561 0.047L8.672 15.422c0.323 -0.323 0.417 -0.806 0.244 -1.228S8.33 13.5 7.875 13.5H1.875c-0.623 0 -1.125 0.502 -1.125 1.125" />
    </Svg>
  );
};

const renderQuestion = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 15 24" fill={color}>
      <Path d="M3.75 7.5c0 -1.655 1.345 -3 3 -3h1.5c1.655 0 3 1.345 3 3v0.169c0 1.022 -0.52 1.973 -1.378 2.522l-1.978 1.27a4.124 4.124 0 0 0 -1.894 3.469v0.07c0 0.83 0.67 1.5 1.5 1.5s1.5 -0.67 1.5 -1.5v-0.066c0 -0.384 0.197 -0.741 0.516 -0.947l1.978 -1.27c1.716 -1.106 2.756 -3.005 2.756 -5.048V7.5c0 -3.314 -2.686 -6 -6 -6h-1.5C3.436 1.5 0.75 4.186 0.75 7.5c0 0.83 0.67 1.5 1.5 1.5s1.5 -0.67 1.5 -1.5m3.75 15a1.875 1.875 0 1 0 0 -3.75 1.875 1.875 0 1 0 0 3.75" />
    </Svg>
  );
};

const renderList = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill={color}>
      <Path d="M1.875 2.25c-0.623 0 -1.125 0.502 -1.125 1.125v2.25c0 0.623 0.502 1.125 1.125 1.125h2.25c0.623 0 1.125 -0.502 1.125 -1.125V3.375c0 -0.623 -0.502 -1.125 -1.125 -1.125zm7.125 0.75c-0.83 0 -1.5 0.67 -1.5 1.5s0.67 1.5 1.5 1.5h13.5c0.83 0 1.5 -0.67 1.5 -1.5s-0.67 -1.5 -1.5 -1.5zm0 7.5c-0.83 0 -1.5 0.67 -1.5 1.5s0.67 1.5 1.5 1.5h13.5c0.83 0 1.5 -0.67 1.5 -1.5s-0.67 -1.5 -1.5 -1.5zm0 7.5c-0.83 0 -1.5 0.67 -1.5 1.5s0.67 1.5 1.5 1.5h13.5c0.83 0 1.5 -0.67 1.5 -1.5s-0.67 -1.5 -1.5 -1.5zM0.75 10.875v2.25c0 0.623 0.502 1.125 1.125 1.125h2.25c0.623 0 1.125 -0.502 1.125 -1.125v-2.25c0 -0.623 -0.502 -1.125 -1.125 -1.125H1.875c-0.623 0 -1.125 0.502 -1.125 1.125m1.125 6.375c-0.623 0 -1.125 0.502 -1.125 1.125v2.25c0 0.623 0.502 1.125 1.125 1.125h2.25c0.623 0 1.125 -0.502 1.125 -1.125v-2.25c0 -0.623 -0.502 -1.125 -1.125 -1.125z" />
    </Svg>
  );
};

const renderCompany = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 18 24" fill={color}>
      <Path d="M2.25 0C1.008 0 0 1.008 0 2.25v19.5c0 1.242 1.008 2.25 2.25 2.25h4.5v-3.75c0 -1.242 1.008 -2.25 2.25 -2.25s2.25 1.008 2.25 2.25v3.75h4.5c1.242 0 2.25 -1.008 2.25 -2.25V2.25c0 -1.242 -1.008 -2.25 -2.25 -2.25zm0.75 11.25c0 -0.413 0.338 -0.75 0.75 -0.75h1.5c0.413 0 0.75 0.338 0.75 0.75v1.5c0 0.413 -0.338 0.75 -0.75 0.75H3.75c-0.413 0 -0.75 -0.338 -0.75 -0.75zm5.25 -0.75h1.5c0.413 0 0.75 0.338 0.75 0.75v1.5c0 0.413 -0.338 0.75 -0.75 0.75h-1.5c-0.413 0 -0.75 -0.338 -0.75 -0.75v-1.5c0 -0.413 0.338 -0.75 0.75 -0.75m3.75 0.75c0 -0.413 0.338 -0.75 0.75 -0.75h1.5c0.413 0 0.75 0.338 0.75 0.75v1.5c0 0.413 -0.338 0.75 -0.75 0.75h-1.5c-0.413 0 -0.75 -0.338 -0.75 -0.75zM3.75 4.5h1.5c0.413 0 0.75 0.338 0.75 0.75v1.5c0 0.413 -0.338 0.75 -0.75 0.75H3.75c-0.413 0 -0.75 -0.338 -0.75 -0.75v-1.5c0 -0.413 0.338 -0.75 0.75 -0.75m3.75 0.75c0 -0.413 0.338 -0.75 0.75 -0.75h1.5c0.413 0 0.75 0.338 0.75 0.75v1.5c0 0.413 -0.338 0.75 -0.75 0.75h-1.5c-0.413 0 -0.75 -0.338 -0.75 -0.75zm5.25 -0.75h1.5c0.413 0 0.75 0.338 0.75 0.75v1.5c0 0.413 -0.338 0.75 -0.75 0.75h-1.5c-0.413 0 -0.75 -0.338 -0.75 -0.75v-1.5c0 -0.413 0.338 -0.75 0.75 -0.75" />
    </Svg>
  );
};

const renderLock = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 24 24" fill="none">
      <Rect
        x="5"
        y="11"
        width="14"
        height="10"
        rx="2"
        ry="2"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8 11V7a4 4 0 1 1 8 0v4"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Circle cx="12" cy="16" r="1" fill={color} />
    </Svg>
  );
};

const renderInvestigation = (color: ColorValue) => {
  return (
    <Svg viewBox="0 0 39 37" fill="none">
      <Mask id="path-1-inside-1_245_3339" fill="white">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8369 21.8706L3.8617 13.4854C3.4093 13.1686 3.29935 12.5451 3.61613 12.0927L7.79504 6.12458C8.11182 5.67217 8.73536 5.56222 9.18777 5.879L21.163 14.2641L25.229 14.8499L17.778 25.491L15.8369 21.8706Z"
        />
      </Mask>
      <Path
        d="M15.8369 21.8706L17.5996 20.9255L17.3744 20.5056L16.9841 20.2323L15.8369 21.8706ZM3.8617 13.4854L5.00885 11.8471L3.8617 13.4854ZM9.18777 5.879L10.3349 4.2407L9.18777 5.879ZM21.163 14.2641L20.0158 15.9024L20.4062 16.1758L20.8778 16.2437L21.163 14.2641ZM25.229 14.8499L26.8673 15.9971L28.7321 13.3339L25.5142 12.8704L25.229 14.8499ZM17.778 25.491L16.0154 26.4361L17.5516 29.3013L19.4163 26.6382L17.778 25.491ZM16.9841 20.2323L5.00885 11.8471L2.71455 15.1237L14.6898 23.5089L16.9841 20.2323ZM5.00885 11.8471C5.46126 12.1639 5.57121 12.7874 5.25443 13.2398L1.97782 10.9455C1.02749 12.3027 1.35733 14.1734 2.71455 15.1237L5.00885 11.8471ZM5.25443 13.2398L9.43334 7.27173L6.15673 4.97743L1.97782 10.9455L5.25443 13.2398ZM9.43334 7.27173C9.11657 7.72413 8.49302 7.83409 8.04061 7.51731L10.3349 4.2407C8.9777 3.29036 7.10707 3.62021 6.15673 4.97743L9.43334 7.27173ZM8.04061 7.51731L20.0158 15.9024L22.3101 12.6258L10.3349 4.2407L8.04061 7.51731ZM20.8778 16.2437L24.9438 16.8295L25.5142 12.8704L21.4482 12.2846L20.8778 16.2437ZM23.5907 13.7028L16.1397 24.3439L19.4163 26.6382L26.8673 15.9971L23.5907 13.7028ZM19.5407 24.546L17.5996 20.9255L14.0743 22.8156L16.0154 26.4361L19.5407 24.546Z"
        fill="#FCFEFE"
        mask="url(#path-1-inside-1_245_3339)"
      />
      <Mask id="path-3-inside-2_245_3339" fill="white">
        <Path d="M29.2573 17.3159C29.7097 17.6327 29.8196 18.2563 29.5028 18.7087L22.6199 28.5385C22.3031 28.9909 21.6796 29.1009 21.2272 28.7841L17.9506 26.4898L25.9807 15.0216L29.2573 17.3159Z" />
      </Mask>
      <Path
        d="M29.2573 17.3159C29.7097 17.6327 29.8196 18.2563 29.5028 18.7087L22.6199 28.5385C22.3031 28.9909 21.6796 29.1009 21.2272 28.7841L17.9506 26.4898L25.9807 15.0216L29.2573 17.3159Z"
        stroke="#FCFEFE"
        strokeWidth={4}
        mask="url(#path-3-inside-2_245_3339)"
      />
      <Path
        d="M31.6829 18.5377L36.3932 18.2364"
        stroke="#FCFEFE"
        strokeLinecap="round"
      />
      <Path
        d="M27.3696 24.5395L32.6148 28.2122"
        stroke="#FCFEFE"
        strokeLinecap="round"
      />
      <Path
        d="M25.2734 34.9537L23.6849 30.5048"
        stroke="#FCFEFE"
        strokeLinecap="round"
      />
      <Rect
        x={16.9281}
        y={16.6178}
        width={1}
        height={5}
        rx={0.5}
        transform="rotate(125 16.9281 16.6178)"
        stroke="#FCFEFE"
      />
      <Line
        x1={15.5766}
        y1={15.0611}
        x2={14.4294}
        y2={16.6994}
        stroke="#13261A"
      />
    </Svg>
  );
};

const renderLockedIcon = (color: ColorValue) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.97801 2.16244H6.41091C7.90376 2.16244 9.11395 3.37263 9.11395 4.86549V7.24128H3.27497V4.86548C3.27497 3.37263 4.48516 2.16244 5.97801 2.16244ZM1.11253 7.24128V4.86548C1.11253 2.17835 3.29088 0 5.97801 0H6.41091C9.09804 0 11.2764 2.17835 11.2764 4.86549V7.24128H11.3077C11.9049 7.24128 12.3889 7.72536 12.3889 8.3225V15.7874C12.3889 16.3846 11.9049 16.8687 11.3077 16.8687H1.08122C0.484078 16.8687 0 16.3846 0 15.7874V8.3225C0 7.72535 0.484078 7.24128 1.08122 7.24128H1.11253Z"
      fill="#FCFEFE"
    />
  </svg>
);

const renderUnlockedIcon = (color: ColorValue) => (
  <Svg width={32} height={32} viewBox="0 0 16 20" fill="none">
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.41093 2.7044H5.97803C4.48518 2.7044 3.27499 3.9146 3.27499 5.40745V9.6874H11.3077C11.9049 9.6874 12.3889 10.1715 12.3889 10.7686V18.2336C12.3889 18.8307 11.9049 19.3148 11.3077 19.3148H1.08122C0.484078 19.3148 0 18.8307 0 18.2336V10.7686C0 10.1715 0.484078 9.6874 1.08122 9.6874H1.11255V5.40745C1.11255 2.72031 3.2909 0.541962 5.97803 0.541962H6.41093C9.09806 0.541962 11.2764 2.72031 11.2764 5.40745V6.29181H9.11398V5.40745C9.11398 3.91459 7.90378 2.7044 6.41093 2.7044Z"
      fill={String(color)}
    />
  </Svg>
);

const renderDraftIcon = (color: ColorValue) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.48145 1.36951L9.33398 1.37537H9.91699C10.0678 1.37524 10.1942 1.48142 10.2246 1.62341L10.2314 1.68689L10.249 3.71619C10.2543 4.32876 10.7207 4.83059 11.3174 4.89294L11.4385 4.89978L13.7803 4.90857C13.932 4.90917 14.0581 5.01742 14.0869 5.16052L14.0928 5.224L14.0752 9.39099V17.1039C14.0751 17.2772 13.935 17.4181 13.7617 17.4183H2.48145C2.308 17.4183 2.16709 17.2773 2.16699 17.1039V1.68396C2.16699 1.53214 2.27484 1.40467 2.41797 1.37537L2.48145 1.36951Z"
      stroke="white"
      strokeWidth="0.87943"
    />
    <path
      d="M3.48584 4.00146H8.8634"
      stroke="white"
      strokeWidth="0.87943"
      strokeLinecap="round"
    />
    <path
      d="M3.48584 6.54443H12.2448"
      stroke="white"
      strokeWidth="0.87943"
      strokeLinecap="round"
    />
    <rect
      x="5.25966"
      y="15.1902"
      width="13.3102"
      height="2.8752"
      rx="0.378854"
      transform="rotate(-45.082 5.25966 15.1902)"
      fill="#38635E"
      stroke="white"
      strokeWidth="0.757709"
    />
    <line
      x1="13.2745"
      y1="7.54766"
      x2="15.1584"
      y2="9.43161"
      stroke="white"
      strokeWidth="0.757709"
    />
    <path
      d="M4.91119 18.571C4.47057 18.8256 3.96574 18.4116 4.08623 17.9504L4.1187 17.8574L5.16637 15.5103C5.32143 15.1629 5.77065 15.0675 6.05335 15.322L7.23048 16.3819C7.49522 16.6205 7.46932 17.036 7.19407 17.244L7.13599 17.2837L4.91119 18.571Z"
      fill="#38635E"
      stroke="white"
      strokeWidth="0.757709"
    />
    <line
      x1="6.66888"
      y1="15.6227"
      x2="12.9848"
      y2="9.30686"
      stroke="white"
      strokeWidth="0.757709"
    />
    <path d="M10.1855 1.60706L13.8061 4.92656" stroke="white" />
  </svg>
);

const renderSorterIcon = (color: ColorValue) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.25708 1.45566H14.1384"
      stroke="#076862"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M3.58484 6.95566L11.8107 6.95566"
      stroke="#076862"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M5.92871 12.4557L9.4668 12.4557"
      stroke="#076862"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

const renderZipIcon = (color: ColorValue) => (
  <Svg width={38} height={32} viewBox="0 0 38 32" fill="none">
    <G clipPath="url(#clip0_3_82)">
      <Mask id="path-1-inside-1_3_82" fill="white">
        <Path d="M15.9863 0C16.6541 0 17.2783 0.333499 17.6494 0.888672L20.5244 5.18945H36C37.1045 5.18945 37.9999 6.08494 38 7.18945V30C38 31.1046 37.1046 32 36 32H2C0.895431 32 3.23539e-08 31.1046 0 30V2C1.11358e-07 0.895431 0.895431 1.91413e-09 2 0H15.9863Z" />
      </Mask>
      <Path
        d="M17.6494 0.888672L20.1435 -0.778564L20.1434 -0.77861L17.6494 0.888672ZM20.5244 5.18945L18.0304 6.85669L18.9213 8.18945H20.5244V5.18945ZM38 7.18945H41V7.18927L38 7.18945ZM36 32V35V32ZM0 30H-3V30H0ZM0 2L-3 2V2H0ZM2 0V-3V0ZM15.9863 0V3C15.6525 3 15.341 2.83359 15.1554 2.55595L17.6494 0.888672L20.1434 -0.77861C19.2156 -2.1666 17.6558 -3 15.9863 -3V0ZM17.6494 0.888672L15.1554 2.55591L18.0304 6.85669L20.5244 5.18945L23.0185 3.52222L20.1435 -0.778564L17.6494 0.888672ZM20.5244 5.18945V8.18945H36V5.18945V2.18945H20.5244V5.18945ZM36 5.18945V8.18945C35.4475 8.18945 35 7.74165 35 7.18963L38 7.18945L41 7.18927C40.9998 4.42823 38.7616 2.18945 36 2.18945V5.18945ZM38 7.18945H35V30H38H41V7.18945H38ZM38 30H35C35 29.4477 35.4477 29 36 29V32V35C38.7614 35 41 32.7614 41 30H38ZM36 32V29H2V32V35H36V32ZM2 32V29C2.55228 29 3 29.4477 3 30H0H-3C-3 32.7614 -0.761424 35 2 35V32ZM0 30H3V2H0H-3V30H0ZM0 2L3 2C3 2.55228 2.55229 3 2 3V0V-3C-0.761424 -3 -3 -0.761423 -3 2L0 2ZM2 0V3H15.9863V0V-3H2V0Z"
        fill="#FCFEFE"
        mask="url(#path-1-inside-1_3_82)"
      />
      <Rect x={15.5685} y={17.999} width={3} height={3} fill="#FCFEFE" />
      <Rect x={3.08276} y={17.999} width={3} height={3} fill="#FCFEFE" />
      <Rect x={27.9387} y={17.999} width={3} height={3} fill="#FCFEFE" />
      <Rect x={21.8114} y={17.999} width={3} height={3} fill="#FCFEFE" />
      <Rect x={9.32568} y={17.999} width={3} height={3} fill="#FCFEFE" />
      <Rect x={34.1815} y={17.999} width={3} height={3} fill="#FCFEFE" />
      <Rect x={18.6899} y={14.8838} width={3} height={3} fill="#FCFEFE" />
      <Rect x={6.20422} y={14.8838} width={3} height={3} fill="#FCFEFE" />
      <Rect x={31.0602} y={14.8838} width={3} height={3} fill="#FCFEFE" />
      <Rect x={0.0769043} y={14.8838} width={3} height={3} fill="#FCFEFE" />
      <Rect x={24.9329} y={14.8838} width={3} height={3} fill="#FCFEFE" />
      <Rect x={12.4471} y={14.8838} width={3} height={3} fill="#FCFEFE" />
      <Rect x={37.303} y={14.8838} width={3} height={3} fill="#FCFEFE" />
    </G>
    <Defs>
      <ClipPath id="clip0_3_82">
        <Rect width={38} height={32} fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);

const renderDocAvailableOffline = (color: ColorValue) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none">
    <g clipPath="url(#clip0_1_210)">
      <path
        d="M2.12152 16.7292C2.7071 16.7294 3.18207 17.2051 3.18207 17.7907V20.5827H14.2612C14.8469 20.5827 15.3217 21.0575 15.3217 21.6432V22.7038C15.3216 23.2894 14.8468 23.7643 14.2612 23.7643H1.06097C1.0245 23.7643 0.988103 23.7621 0.952576 23.7585C0.41768 23.7044 0.000569123 23.2529 0.000427246 22.7038V17.7907C0.000427272 17.205 0.475236 16.7292 1.06097 16.7292H2.12152Z"
        fill="#38635E"
      />
      <path
        d="M13.4165 21.6434C13.4168 21.058 13.8916 20.583 14.4771 20.5829H20.8179V17.7899C20.8179 17.2042 21.2928 16.7294 21.8785 16.7294H22.939C23.5247 16.7294 23.9996 17.2042 23.9996 17.7899V22.704C23.9996 23.2897 23.5247 23.7655 22.939 23.7655H14.4771C13.8915 23.7654 13.4165 23.2896 13.4165 22.704V21.6434Z"
        fill="#38635E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5503 3.11375C20.8032 2.8741 21.202 2.88483 21.4417 3.13768L22.7439 4.51086C22.9836 4.76374 22.9736 5.16366 22.7208 5.4034L9.16667 18.252C9.0082 18.4021 8.79253 18.4528 8.5944 18.4084C8.47367 18.3828 8.35887 18.3232 8.26753 18.2269L1.88776 11.4977C1.64802 11.2448 1.65896 10.845 1.91184 10.6053L3.28502 9.3031C3.5379 9.06337 3.93767 9.0743 4.17741 9.32718L8.8248 14.2281L20.5503 3.11375Z"
        fill="#38635E"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_210">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const renderSave = (color: ColorValue) => (
  <svg
    width={27}
    height={27}
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="13.27" cy="13.27" r="13.27" fill="#00645E" />
    <g clipPath="url(#clip0_41_46)">
      <path
        d="M8.62716 6.77002C7.60283 6.77002 6.77002 7.60283 6.77002 8.62716V17.9129C6.77002 18.9372 7.60283 19.77 8.62716 19.77H17.9129C18.9372 19.77 19.77 18.9372 19.77 17.9129V10.8702C19.77 10.3769 19.5756 9.90395 19.2274 9.55573L16.9843 7.31265C16.6361 6.96444 16.1631 6.77002 15.6698 6.77002H8.62716ZM9.55573 9.55573C9.55573 9.04212 9.97069 8.62716 10.4843 8.62716H15.1272C15.6408 8.62716 16.0557 9.04212 16.0557 9.55573V11.4129C16.0557 11.9265 15.6408 12.3414 15.1272 12.3414H10.4843C9.97069 12.3414 9.55573 11.9265 9.55573 11.4129V9.55573ZM13.27 14.1986C14.2943 14.1986 15.1272 15.0314 15.1272 16.0557C15.1272 17.0801 14.2943 17.9129 13.27 17.9129C12.2457 17.9129 11.4129 17.0801 11.4129 16.0557C11.4129 15.0314 12.2457 14.1986 13.27 14.1986Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_41_46">
        <rect
          width="13"
          height="13"
          fill="white"
          transform="translate(6.77002 6.77002)"
        />
      </clipPath>
    </defs>
  </svg>
);
